import { useEffect } from "react";
import { CHARTBEAT_USER_MAPPING } from "@features/analytics/utils/constant";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import useScript from "@hooks/useScript";

/** This component loads all the necessary scripts for Chartbeat in body. */
const ChartbeatBodyScript = (): React.ReactElement => {
  const { userType } = useUserInfo();
  const chartbeatUserType = CHARTBEAT_USER_MAPPING[userType];

  useScript({
    id: "chartbeat-script",
    async: true,
    type: "text/javascript",
    src: "//static.chartbeat.com/js/chartbeat.js",
  });

  useEffect(() => {
    if (typeof window === undefined) return;
    if (!window._data) return;

    console.log("chartbeat: window._data.level2", window._data.level2); // eslint-disable-line no-console
    console.log("chartbeat: window._data.author", window._data.author); // eslint-disable-line no-console

    /** CONFIGURATION START **/
    window._sf_async_config = window._sf_async_config || {};
    window._sf_async_config.sections = window._data.level2;
    window._sf_async_config.authors = window._data.author;

    console.log("chartbeat: _sf_async_config", window._sf_async_config); // eslint-disable-line no-console

    /** 2023-09-07: https://sph.atlassian.net/browse/BT-11820 **/
    window._cbq = window._cbq || [];
    window._cbq.push(["_acct", `"${chartbeatUserType}"`]);
    /** CONFIGURATION END **/
  }, [chartbeatUserType]);

  return <></>;
};

export default ChartbeatBodyScript;
